var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1031 23.2973L1.50311 13.6973C1.03436 13.2285 0.799988 12.6144 0.799988 12.0004C0.799988 11.3863 1.03436 10.7723 1.50311 10.3035L11.1031 0.703519C11.7898 0.0168185 12.8211 -0.188307 13.7187 0.183168C14.6164 0.554643 15.2 1.43004 15.2 2.40039V21.6004C15.2 22.5707 14.6164 23.4461 13.7187 23.8175C12.8211 24.189 11.7898 23.984 11.1031 23.2973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.9a4c7e7fc2891ab1e1793fe11689573d.svg";
export { ForwardRef as ReactComponent };